<div class="relative">
  <input #fileInput type="file" style="display: none;" accept="image/*" (change)="fileSelected($event)" />

  <!-- Show Image if imageSource is available -->
  <img *ngIf="imageSource" [src]="imageSource" [ngClass]="[height, width]"
    class="border border-solid rounded-full cursor-pointer object-cover" (click)="triggerInputClick()"
    (error)="onImageError()" />

  <!-- Show SVG if imageSource is not available -->
  <svg *ngIf="!imageSource" xmlns="http://www.w3.org/2000/svg" [attr.width]="'100%'" [attr.height]="'100%'"
    viewBox="0 0 24 24" [ngClass]="[height, width]"
    class="border-menu-list-color border border-solid rounded-full cursor-pointer" (click)="triggerInputClick()">
    <path fill="#949595"
      d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4" />
  </svg>
</div>